import React from "react";
import { TextField } from "@mui/material";
import "./components.css";
import { getLocalizedFieldLabel } from "../helpers/helpers";

export default function NumberFieldComponent(props) {
  const { questionKey, value, onChange, error, helperText, label, lang } = props;

  const handleChange = (e) => {
    const val = e.target.value;
    if (val.length > 9) return;
    const parsedValue = val === "" ? "" : parseFloat(val);
    onChange(questionKey, parsedValue);
  };

  return (
    <div className="flexAlignColumnClassName">
      <TextField
      label={getLocalizedFieldLabel(questionKey, lang) || label}
        autoComplete="off"
        type="number"
        id={`outlined-number-${questionKey}`}
        className="numberFieldInputComponent"
        value={value}
        onChange={handleChange}
        error={!!error}
        helperText={helperText}
        inputProps={{ maxLength: 9 }}
        InputProps={{
          classes: {
            root: `outlinedInputRoot ${error ? 'error' : ''}`,
            focused: `outlinedInputFocused ${error ? 'error' : ''}`,
            notchedOutline: "outlinedInput",
          },
        }}
        InputLabelProps={{
          classes: {
            root: "outlinedInputLabel",
            focused: "focusedInputLabel"
          }
        }}
      />
    </div>
  );
}
